import { PostId } from "./RootPost";

export class UserProperties {
    public infoNeeded: string[] = [];
    public infoProvided: string[] = [];

    // Contains data about items that I created, voted, or commented on:
    //  true: items need more info but no info is given,
    //  false: items need more info and is given
    public needMoreInfoFromMe: { [trackingId: string]: boolean } = {};

    public markInfoProvided(trackingId: string): void {
        // eslint-disable-next-line security/detect-object-injection
        this.needMoreInfoFromMe[trackingId] = false;

        if (!this.infoProvided.some((id: string) => id === trackingId)) {
            this.infoProvided.push(trackingId);
        }

        this.infoNeeded = this.infoNeeded.filter((id: string) => {
            return id !== trackingId;
        });
    }
}

export class ActivityResults {
    public activities: Activity[] = [];
    public totalCount: number = 0;
}

export class Activity {
    public rootTitle: string;
    public rootPostId: PostId;
    public activity: string;
    public date: Date;
}
